export const validPhoneNumber = (phoneNumber: string): boolean => {
    var phoneRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
    return phoneRegex.test(phoneNumber);
}

export const validUsername = (username: string): boolean => {
    var usernameRegex = /^[a-zA-Z0-9\-\.\_]+$/;
    return usernameRegex.test(username);
}